/** Separate URL, API, cookies and browser caches for each customer database. */
export const instancePath = typeof location === "undefined" ? "" : location.pathname.match(/^\/i\/[0-9a-f-]{36}(?=\/|$)/)?.[0] ?? "";
export const instanceHref = (path: string) => path.startsWith("/api/") ? `${instancePath}${path}` : path;
